<template>
  <div class="own-reports">
    <TheFilters
      :inquiry="inquiry"
      :activeObjects="activeObjects"
      :fromReports="true"
      :reports="reports"
      :showAllReports="showAllReports"
      :queryObject="queryObject"
      :isInquiryMade="isInquiryMade"
      @setActiveObjects="activeObjects = $event"
      @setFormatedFromDate="formatedFromDate = $event"
      @setFormatedToDate="formatedToDate = $event"
      @selectReportsType="selectReportsType($event)"
      @getInquiry="getReports()"
      @reset="resetReports()"
      @resetInquiry="reports = []"
      @exportToExcelFile="exportFile()"
    />

    <div class="table-wrapper">
      <p v-if="!reports.length && isInquiryMade" class="no-reports">
        {{ $t("no-own-reports") }}
      </p>
      <table v-else-if="reports.length" class="table" ref="table">
        <thead>
          <tr>
            <th>{{ $t("date") | capitalize }}</th>
            <th>{{ $t("company") }}</th>
            <th>{{ $t("site") }}</th>
            <th>{{ $t("part") }}</th>
            <th class="center">{{ $t("reported") }} {{ $t("materials") }}</th>
            <th class="center">Общо лв. по отчета</th>
            <th class="center">Сума по заработка</th>
            <th
              v-if="
                getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin
              "
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(r, i) in filtered"
            :key="`findReport-${i}-${r._id}`"
            @click="viewReport(r._id)"
            :class="{ 'tr-invalid': r.isInvalid }"
            class="no-hover"
          >
            <td :rowspan="r.mergeRows" v-if="!r.alreadyMerged">
              <span class="no-wrap">{{ r.date | formatDate }} г.</span>
            </td>
            <td
              class="td-company-name"
              :rowspan="r.mergeRows"
              v-if="!r.alreadyMerged"
            >
              <img
                class="td-invalid-flag"
                v-if="r.isInvalid"
                src="../assets/img/flag_yes.svg"
                alt="invalid"
              />
              {{ r.company.companyName }}
            </td>
            <td :rowspan="r.mergeRows" v-if="!r.alreadyMerged">
              {{ r.object.objectName }}
            </td>
            <td :class="{ 'not-first': r.alreadyMerged }">
              {{ r.part ? r.part.partName : "" }}
            </td>
            <td class="center">{{ r.materials.length }}</td>
            <td class="center">{{ r.reportTotalSum }} {{ $t("currency") }}</td>
            <td class="center">
              {{ r.reportTotalZarabotka }} {{ $t("currency") }}
            </td>
            <td
              v-if="
                getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin
              "
            >
              <img
                class="flag-indicator"
                v-if="r.priceStatus === 2"
                src="../assets/img/green.svg"
                :alt="$t('all-amounts-entered')"
                :title="$t('all-amounts-entered')"
              />
              <img
                class="flag-indicator"
                v-else-if="r.priceStatus === 1"
                src="../assets/img/yellow.svg"
                :alt="$t('missing-amounts-entered')"
                :title="$t('missing-amounts-entered')"
              />
              <img
                class="flag-indicator"
                v-else-if="r.priceStatus === 0"
                src="../assets/img/red.svg"
                :alt="$t('no-amounts-entered')"
                :title="$t('no-amounts-entered')"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- BUTTONS FOR MOBILE -->
    <footer class="modal-footer mobile">
      <div
        class="new-content-data-item-toggle-circle mobile excel"
        v-if="this.reports.length"
        @click="exportFile()"
      >
        <span class="tms">E</span>
      </div>
      <!-- <div
        class="new-content-data-item-toggle-circle mobile"
        @click="newReport()"
      >
        <span class="tms">L</span>
      </div> -->
    </footer>
  </div>
</template>

<script>
import TheFilters from "../components/shared/TheFilters.vue";
import hours from "./mixins/hours.js";
import { mapGetters } from "vuex";
import XLSX from "xlsx";

export default {
  mixins: [hours],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    notAdminOrSuperAdmin() {
      return (
        !this.getUser.permissions.isSuperAdmin &&
        !this.getUser.permissions.isAdmin
      );
    },
  },
  components: {
    TheFilters,
  },
  data() {
    return {
      reports: [],
      filtered: [],
      search: "",
      formatedFromDate: null,
      formatedToDate: null,
      showAllReports: false,
      isInquiryMade: false,
      filtersChanged: false,
      activeObjects: true,
      queryObject: {},
      inquiry: {
        fromDate: "",
        toDate: "",
        company: {
          _id: "",
          companyName: "",
        },
        object: {
          _id: "",
          objectName: "",
        },
        part: {
          _id: "",
          partName: "",
        },
        reporter: {
          _id: "",
          name: "",
        },
        worker: {
          _id: "",
          name: "",
        },
        isInvalid: false,
        priceStatus: null,
        search: "",
      },
    };
  },
  methods: {
    resetReports() {
      this.reports = [];
      this.isInquiryMade = false;
    },
    selectReportsType(v) {
      this.showAllReports = v;
      this.queryObject.showAllReports = v;
      this.getReports();
    },
    // Filter reports by date, companyName, partName or objectName
    searchFilter() {
      const filtered = this.reports.filter((r) => {
        this.$delete(r, "alreadyMerged");
        this.$delete(r, "mergeRows");
        return (
          r.date.toLowerCase().includes(this.search.toLowerCase()) ||
          r.company.companyName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          r.object.objectName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          r.part.partName.toLowerCase().includes(this.search.toLowerCase())
          // || r.part.partName.toLowerCase().includes(this.search.toLowerCase())
        );
      });

      filtered.map((r, i) => {
        let counter = 1;
        for (let j = i + 1; j < filtered.length; j++) {
          if (filtered[j]._id === r._id && !filtered[j].alreadyMerged) {
            counter++;
            this.$set(filtered[j], "alreadyMerged", true);
          } else break;
        }
        if (counter > 1) this.$set(r, "mergeRows", counter);
      });

      return filtered;
    },
    viewReport(id) {
      this.$router.push(`/reports/edit/${id}?back=true`);
    },
    // getStatuses() {
    //   if (this.reports.length) {
    //     this.reports.forEach((r) => {
    //       let status = 2;
    //       let total = 0;

    //       for (let tag of ["materials", "activities"]) {
    //         if (r[tag]) {
    //           r[tag].forEach((x) => {
    //             total += +x.price;
    //             if (!x.price) {
    //               status = 1;
    //             }
    //           });
    //         }
    //       }

    //       if (!total) {
    //         status = 0;
    //       }

    //       r.priceStatus = status;
    //     });
    //   }
    // },
    getUrl() {
      // this.inquiry.search = this.inquiry.search.replace('/', '');

      let url = `${process.env.VUE_APP_BASE_URI}/report/inquiry`;
      url += `/${this.inquiry.company._id ? this.inquiry.company._id : 0}`;
      // url += `/${this.inquiry.project._id ? this.inquiry.project._id : 0}`;
      url += `/${this.inquiry.object._id ? this.inquiry.object._id : 0}`;
      url += `/${this.inquiry.part._id ? this.inquiry.part._id : 0}`;
      url += `/${
        !this.showAllReports ? this.getUser._id : 0
        // !this.showAllReports
        //   ? this.getUser._id
        //   : this.inquiry.reporter._id
        //   ? this.inquiry.reporter._id
        //   : 0
      }`;
      url += `/${
        0
        // this.notAdminOrSuperAdmin
        //   ? this.getUser._id
        //   : this.inquiry.worker._id
        //   ? this.inquiry.worker._id
        //   : 0
      }`;
      url += `/${this.inquiry.fromDate.toISOString()}`;
      url += `/${this.inquiry.toDate.toISOString()}`;
      url += `/${this.inquiry.isInvalid}`;
      url += `/${this.activeObjects}`;
      url += `/${this.inquiry.priceStatus}`;
      url += `/${
        this.inquiry.search ? encodeURIComponent(this.inquiry.search) : null
      }`;

      url += "?fromReports=true";

      return url;
    },
    getReports() {
      this.$store.dispatch("startLoading");
      // let id = this.getUser._id;
      // let url = `${process.env.VUE_APP_BASE_URI}/report/myreports/${id}`;
      let url = this.getUrl();

      // if (this.showAllReports) url = `${process.env.VUE_APP_BASE_URI}/report`;
      this.$router.push({ query: this.queryObject }).catch((err) => err);

      this.$http
        .get(url)
        .then((response) => {
          this.reports = response.data;
          this.filtered = this.searchFilter();

          this.$store.dispatch("stopLoading");
          this.isInquiryMade = true;
          if (
            this.getUser.permissions.isSuperAdmin ||
            this.getUser.permissions.isAdmin
          ) {
            // this.getStatuses();
          }
        })
        .catch((error) => console.log(error));
    },
    loadQueries(query) {
      if (Object.keys(query).length) {
        if (query.fromDate) {
          this.inquiry.fromDate = new Date(query.fromDate);
          this.queryObject.fromDate = query.fromDate;
        }
        if (query.toDate) {
          this.inquiry.toDate = new Date(query.toDate);
          this.queryObject.toDate = query.toDate;
        }
        if (query.company) {
          this.inquiry.company._id = query.company;
          this.queryObject.company = query.company;
        }
        if (query.companyName) {
          this.inquiry.company.companyName = query.companyName;
          this.queryObject.companyName = query.companyName;
        }
        if (query.object) {
          this.inquiry.object._id = query.object;
          this.queryObject.object = query.object;
        }
        if (query.objectName) {
          this.inquiry.object.objectName = query.objectName;
          this.queryObject.objectName = query.objectName;
        }
        if (query.part) {
          this.inquiry.part._id = query.part;
          this.queryObject.part = query.part;
        }
        if (query.partName) {
          this.inquiry.part.partName = query.partName;
          this.queryObject.partName = query.partName;
        }
        if (query.reporter) {
          this.inquiry.reporter._id = query.reporter;
          this.queryObject.reporter = query.reporter;
        }
        if (query.reporterName) {
          this.inquiry.reporter.name = query.reporterName;
          this.queryObject.reporterName = query.reporterName;
        }
        if (query.worker) {
          this.inquiry.worker._id = query.worker;
          this.queryObject.worker = query.worker;
        }
        if (query.workerName) {
          this.inquiry.worker.name = query.workerName;
          this.queryObject.workerName = query.workerName;
        }
        if (query.isInvalid) {
          const isInvalid = query.isInvalid == "true" ? true : false;
          this.inquiry.isInvalid = isInvalid;
          this.queryObject.isInvalid = isInvalid;
        }
        if (query.active) {
          const active = query.active == "true" ? true : false;
          this.activeObjects = active;
          this.queryObject.active = active;
        }
        if (query.tab) {
          this.selectTab(+query.tab);
        }
        if (query.period) {
          this.datePeriod = query.period;
          this.queryObject.period = query.period;
        }
        if (query.status) {
          this.selectPriceStatus(+query.status);
        }
        if (query.search) {
          this.inquiry.search = query.search;
        }
        if (query.showAllReports) {
          this.inquiry.showAllReports = query.showAllReports;
          this.queryObject.showAllReports = query.showAllReports;
          this.selectReportsType(query.showAllReports);
        }
      }
      this.getReports();
    },
    selectPriceStatus(p) {
      this.resetReports();
      if (p === this.inquiry.priceStatus) {
        this.inquiry.priceStatus = null;
      } else {
        this.inquiry.priceStatus = p;
      }
      this.queryObject.status = p;
      this.$router.push({ query: this.queryObject }).catch((err) => err);
    },
    newReport() {
      this.$router.push("/reports/new");
    },
    // Export To Excel
    exportFile() {
      let worksheet = XLSX.utils.table_to_sheet(this.$refs.table);
      let new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet, `Reports`);
      XLSX.writeFile(new_workbook, `report-${Date.now()}.xlsx`);
    },
  },
  mounted() {
    this.loadQueries(this.$route.query);
  },
  updated() {
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
      this.filtered = this.searchFilter();
      // console.log(this.search);
    });
  },
  destroyed() {
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped>
.own-reports {
  padding: 10px 40px;
}
/* .own-reports-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
} */
.table-wrapper {
  overflow: auto;
}
.desktop {
  display: flex;
}
.mobile {
  display: none;
}
.no-reports {
  background-color: #fff;
  font-size: 18px;
  text-align: center;
  padding: 20px;
}
tr td:last-child {
  width: 1%;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .mobile {
    display: flex;
  }
  .table-wrapper {
    overflow: auto;
  }
  .own-reports {
    padding: 10px 15px;
  }
  .own-reports-header {
    display: none;
  }
  .btns.mobile {
    position: fixed;
    display: flex;
    float: left;
    flex-direction: column-reverse;
    justify-items: flex-end;
  }
  .new-content-data-item-toggle-circle {
    width: 50px;
    height: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: green;
    /* bottom: 75px; */
    cursor: pointer;
    right: 20px;
    position: fixed;
  }
  .new-content-data-item-toggle-circle .tms {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background-color: #fff;
    /* height: 125px; */
    padding: 0px;
  }
}
</style>
